<template>
    <a
        :href="link"
        class="link"
        :class="{ '-is-black': isBlack, icon: icon }"
        :target="target"
    >
        {{ text }}
        <svg class="icon icon-arrow" v-if="icon">
            <use xlink:href="#icon-arrow"></use>
        </svg>
    </a>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: "",
        },
        isBlack: {
            type: Boolean,
            default: false,
        },
        link: {
            type: String,
            default: "#",
        },
        icon: {
            type: Boolean,
            default: false,
        },
        target: {
            type: String,
            default: "_self",
        },
    },
};
</script>

<style lang="scss" scoped>
.link {
    align-items: center;
    border-bottom: 2px solid;
    color: #fff;
    display: flex;
    font-family: $f-nouvelR-semibold;
    font-size: 1.6rem;
    line-height: 1.8rem;
    padding: 0 0 2px 0;
    position: relative;
    text-decoration: none;
    width: max-content;

    &.-is-black {
        color: $black;

        &::before {
            background: $black;
        }
    }

    &.icon {
        &:hover {
            &::before {
                width: calc(100% - 1.8rem);
            }
        }
    }

    .icon {
        fill: $primary;
        height: 1rem;
        margin-left: 0.8rem;
        width: 1rem;
    }
}
</style>
